/** SPA path — top-level `/events` is routed to the API gateway on production hosts. */
export const EVENTS_PAGE_PATH = "/dashboard/events";
